const useSubscriptionId = (): string => {
  const pathname = window.location.pathname;

  const subscriptionId = pathname.split('/').slice(-1)[0];
  const isSubscriptionIdNumber = subscriptionId;
  return isSubscriptionIdNumber ? subscriptionId : '';
};

export default useSubscriptionId;
